import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import FeedBack_banner from "../../assets/New_banner.svg";
import home from "../../assets/home.svg";
import shield from "../../assets/shield.svg";
import mail from "../../assets/mail.svg";
import linkChain from "../../assets/akar-icons_link-chain.svg";
import { PATHS } from "../../constant";
const SiteMap = () => {
  const [loading, setLoading] = useState(false);
  const footerData = [
    {
      title: "PMG",
      icon: home,
      links: [
        { label: "About Us", to: PATHS.ABOUT_US_PAGE, available: true },
        { label: "How it Works", to: "/", available: false },
        { label: "Key Features", to: "/", available: false },
        { label: "PMG Monitored Projects", to: "/", available: false },
        { label: "FAQ", to: "/", available: false }
      ]
    },
    {
      title: "Legal",
      icon: shield,
      links: [
        { label: "Terms & Conditions", to: "/", available: false },
        { label: "Privacy Policy", to: "/", available: false },
        { label: "Copyright Policy", to: "/", available: false },
        { label: "Hyperlinking Policy", to: "/", available: false }
      ]
    },
    {
      title: "Contact",
      icon: mail,
      links: [
        { label: "Contact Us", to: PATHS.CONTACT_US_PAGE, available: true },
        { label: "Feedback", to: PATHS.FEEDBACK_PAGE, available: true }
      ]
    },
    {
      title: "Quick Links",
      icon: linkChain,
      links: [
        { label: "Best Practices", to: PATHS.BEST_PRACTICES, available: true },
        { label: "Articles", to: PATHS.ARTICLES_DETAILS_PAGE, available: true },
        { label: "PMG Updates", to: "/", available: false },
        { label: "Login", to: PATHS.LOGIN, available: true },
        { label: "Register", to: PATHS.SIGNUP, available: true }
      ]
    }
  ];

  return (
    <div className="about-us-container">
      {/* <LoaderPage loading={loading} /> */}

      <nav aria-label="breadcrumb" className="page-breadcrumb">
        <ol>
          <li>
            <li className="crumb-home">Home</li>
          </li>
          <li className="active" aria-current="page">
            Sitemap
          </li>
        </ol>
      </nav>

      <div className="page-banner">
        <Image src={FeedBack_banner} alt="" className="page-banner-img" />
        <h1 className="page-banner-title">Sitemap</h1>
        <span className="sub-sitemap-text">
          Explore all sections of the PMG portal
        </span>
      </div>
      <section className="pmg-footer">
        <div className="pmg-footer-container">
          {footerData.map((section, index) => (
            <div className="footer-column" key={index}>
              <div className="footer-heading">
                <span className="footer-icon">
                  <img src={section.icon} alt="" />
                </span>
                <h3>{section.title}</h3>
              </div>

              <div className="footer-heading-line" />

              <ul className="footer-links">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    {/* <Link to={link.to}>
                    <span className="footer-arrow">&gt;</span>
                    <span>{link.label}</span>
                  </Link> */}
                    {link.available ? (
                      <Link to={link.to}>
                        <span className="footer-arrow">&gt;</span>
                        <span>{link.label}</span>
                      </Link>
                    ) : (
                      <a
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          window.scrollTo({
                            top: document.documentElement.scrollHeight,
                            behavior: "smooth"
                          });
                        }}
                      >
                        <span>&gt;</span>
                        <span>{link.label}</span>
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default SiteMap;
